module.exports=function(e){var t={};function o(n){if(t[n])return t[n].exports;var r=t[n]={i:n,l:!1,exports:{}};return e[n].call(r.exports,r,r.exports,o),r.l=!0,r.exports}return o.m=e,o.c=t,o.d=function(e,t,n){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)o.d(n,r,function(t){return e[t]}.bind(null,r));return n},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="",o(o.s=62)}({1:function(e,t){e.exports=require("react")},2:function(e,t){e.exports=require("styled-components")},62:function(e,t,o){"use strict";var n=this&&this.__createBinding||(Object.create?function(e,t,o,n){void 0===n&&(n=o),Object.defineProperty(e,n,{enumerable:!0,get:function(){return t[o]}})}:function(e,t,o,n){void 0===n&&(n=o),e[n]=t[o]}),r=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),l=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)"default"!==o&&Object.hasOwnProperty.call(e,o)&&n(t,e,o);return r(t,e),t};Object.defineProperty(t,"__esModule",{value:!0}),t.ListBadge=t.ListContainer=t.BadgeButton=t.ExpandableBadge=void 0;const a=l(o(1)),i=l(o(2)),s=o(63),c=i.default.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`,d=i.default.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: 3px 8px;
  margin: 3px 0 3px 5px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  text-align: right;

  transition: all 0.5s ease-out;
  pointer-events: all;
  user-select: none;
  cursor: pointer;

  color: #ffffffa8;
  background-color: ${({color:e})=>e};
  box-shadow: 0 0 5px ${({color:e})=>e};
  ${({top:e})=>`top: ${e}px;`}
  ${({styles:e})=>e}

  ${({open:e,color:t})=>e&&i.css`
    color: ${t};
    padding: 3px 12px 12px 8px;
    background-color: #000;
  `}
`,u=i.default.div.attrs(()=>({className:"expandable-content"}))`
  display: none;
  transition: all 0.5s ease-out;
  font-weight: normal;
  color: white;

  ${({open:e})=>e&&i.css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `}
`,f=i.default.div.attrs(()=>({className:"extra-info"}))`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;

  padding: 0 5px;
  height: 100%;
  background: #000;
  border-radius: 4px;

  opacity: 0;
  transition: all 0.5s ease-out;

  ${({open:e})=>e&&i.css`
    opacity: 1;
  `}
`,p=i.default.div.attrs(()=>({className:"extra-block"}))`
  display: flex;
  padding: 0px 3px;
  margin: 3px 4px 3px 0px;
  border-radius: 2px;
  font-size: 11px;
  font-weight: bold;
  color: #FFF;
  background-color: ${({color:e})=>e};

  &:last-child {
    margin: 3px 0px;
  }

  &:only-child {
    margin: 3px 0px;
  }
`;t.ExpandableBadge=e=>{const{title:t,content:o,labels:n,color:r,styles:l,show:i}=e,[s,x]=a.useState(i);return a.default.createElement(c,{className:"lego-logger"},a.default.createElement(f,{open:s},n&&n.map((e,t)=>a.default.createElement(p,{key:t,color:e.color},e.name))),a.default.createElement(d,{styles:l,onClick:()=>x(!s),open:s,color:r},t,a.default.createElement(u,{open:s},o&&o())))};const x=i.default.div`
  position: fixed;
  top: 10px;
  right: 10px;

  display: flex;
  flex-direction: column;

  pointer-events: none;
  z-index: 9999999999999;
  opacity: 0.9;

  ${({show:e})=>!e&&i.css`display: none;`}
`;t.BadgeButton=i.default.button`
  background-color: #ffffff20;
  padding: 1px 2px;
  border-radius: 3px;
  border: none;
  outline: none;

  color: white;
  font-size: 9px;
  pointer-events: all;
  cursor: pointer;
`,t.ListContainer=i.default.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: auto;
  max-height: 200px;
  overflow: hidden;
  mask-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0.5)));
  mask-size: 100% 120%;
  overflow-y: scroll;
  pointer-events: all;

  ${({show:e})=>!e&&i.css`display: none;`}
`;const b=(e,o)=>e?e.hide?"":e.childs?a.default.createElement(t.ListBadge,{key:o,title:e.title,list:e.childs,color:e.color,open:e.open}):a.default.createElement(s.Badge,{key:o,show:!0,color:e.color},e.action?a.default.createElement(t.BadgeButton,{onClick:e.action},e.title):e.title):"";t.ListBadge=({title:e,list:o,color:n,badgeStyles:r,open:l})=>{const[i,c]=a.useState(l);return a.default.createElement(a.default.Fragment,null,a.default.createElement(s.Badge,{styles:r,color:n},a.default.createElement(a.default.Fragment,null,""+e,a.default.createElement(t.BadgeButton,{onClick:()=>c(!i)},i?"▲":"▼"))),a.default.createElement(t.ListContainer,{show:i},o.map((e,o)=>{if(e){if(e.childs)return a.default.createElement(t.ListBadge,{key:o,title:e.title,list:e.childs,color:e.color||n});if(e.content)return a.default.createElement(t.ExpandableBadge,{key:o,title:e.title,content:e.content,labels:e.labels,styles:r,color:e.color||n,show:e.open})}return b(e,o)})))};t.default=({data:e,show:t})=>a.default.createElement(x,{show:t},e.map((e,t)=>b(e,t)))},63:function(e,t,o){"use strict";var n=this&&this.__createBinding||(Object.create?function(e,t,o,n){void 0===n&&(n=o),Object.defineProperty(e,n,{enumerable:!0,get:function(){return t[o]}})}:function(e,t,o,n){void 0===n&&(n=o),e[n]=t[o]}),r=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),l=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)"default"!==o&&Object.hasOwnProperty.call(e,o)&&n(t,e,o);return r(t,e),t};Object.defineProperty(t,"__esModule",{value:!0}),t.Badge=t.OtherColors=t.WarningColors=t.NoteColors=t.DangerColors=t.SuccessColors=t.InfoColors=t.NeutralColors=void 0;const a=l(o(2));t.NeutralColors=a.css`
  color: #a3e1ff;
  background-color: #0078b1;
  box-shadow: 0 0 5px #00557d;
`,t.InfoColors=a.css`
  color: #76ffd5;
  background-color: #00776d;
  box-shadow: 0 0 5px #00506f;
`,t.SuccessColors=a.css`
  color: #76ff81;
  background-color: #007725;
  box-shadow: 0 0 5px #006f23;
`,t.DangerColors=a.css`
  color: #ff8576;
  background-color: #b10000;
  box-shadow: 0 0 5px #b10000;
`,t.NoteColors=a.css`
  color: #fff1a3;
  background-color: #8c6f00;
  box-shadow: 0 0 5px #7d5700;
`,t.WarningColors=a.css`
  color: #ffca76;
  background-color: #b13b00;
  box-shadow: 0 0 5px #b13d00;
`,t.OtherColors=a.css`
  color: #dfc2ff;
  background-color: #673f92;
  box-shadow: 0 0 5px #2a0056;
`,t.Badge=a.default.div.attrs(()=>({className:"badge"}))`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 2px 5px;
  margin: 3px 0 3px auto;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;

  transition: all 0.3s ease;
  pointer-events: none;
  user-select: none;
  opacity: 0.6;

  color: #ffffffaf;
  background-color: ${({color:e})=>e};
  box-shadow: 0 0 5px ${({color:e})=>e};
  ${({top:e})=>`top: ${e}px;`}
  ${({rounded:e})=>e&&"border-radius: 100px;"}
  ${({styles:e})=>e}
  /* ${({animation:e})=>e} */

  /* @keyframes moveIn { from{opacity: 0;} to{opacity: 0.6;} }
  @keyframes moveOut { from{opacity: 0.6;} to{opacity: 0;} }

  ${({show:e})=>e&&a.css`
    animation: moveIn 0.5s ease 0s 1 normal;
  `}

  ${({show:e})=>!e&&a.css`
    animation: moveOut 0.5s ease 0s 1 normal;
  `} */
`}});